<template>
  <div class="veda-product">
    <div class="web-box top">
      <a-row>
        <a-col :xs="24" :sm="12">
          <div style="max-width:500px;margin:0 auto">
            <h2>VEDA 广告营销工具</h2>
            <p>强大的素材制作及资源整合配套工具</p>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <div class="animo-wrap web-show">
            <img
              class="top-img"
              src="http://www.vedamobi.com/assets/website/images/tool/top.png"
            />
            <div class="lightbeam"></div>
          </div>
          <img
            class="top-img mobile-show"
            src="http://www.vedamobi.com/assets/website/images/tool/top.png"
          />
        </a-col>
      </a-row>
    </div>
    <div class="label-wrap">
      <h4>VEDA 广告营销工具</h4>
      <div></div>
      <p>分散数据整合技术管理平台</p>
    </div>
    <div class="web-box content">
      <a-row>
        <a-col :xs="24" :sm="12">
          <img
            class="left"
            src="http://www.vedamobi.com/assets/website/images/tool/content1.png"
          />
        </a-col>
        <a-col :xs="24" :sm="12">
          <div class="text-wrap right">
            <p class="text">
              广告投放工具库
              <br />- H5落地页制作 <br />- 营销表单生成 <br />- 创意灵感库
              <br />- 投放创意排行榜
            </p>
            <p class="button" @click="goCallUs">联系我们</p>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="web-box content">
      <a-row>
        <a-col :xs="24" :sm="12">
          <div class="text-wrap left">
            <p class="text">
              资源整合工具
              <br />- 支持站内商务资源整合 <br />- 支持在内日程备忘录插件
              <br />- 支持线上视频培训教程
            </p>
            <p class="button" @click="goCallUs">联系我们</p>
          </div>
        </a-col>
        <a-col :xs="24" :sm="12">
          <img
            class="right"
            src="http://www.vedamobi.com/assets/website/images/tool/content2.png"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import ScrollReveal from 'scrollreveal'
export default {
  data () {
    return {
      scrollReveal: ScrollReveal()
    }
  },
  mounted () {
    this.scrollReveal.reveal(`.left`, {
      // 动画的时长
      duration: 600,
      // 延迟时间
      delay: 200,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: 'left',
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: false,
      // 滚动的距离，单位可以用%，rem等
      distance: '200px',
      // 其他可用的动画效果
      opacity: 0.001,
      easing: 'linear'
    })
    this.scrollReveal.reveal(`.right`, {
      // 动画的时长
      duration: 600,
      // 延迟时间
      delay: 200,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: 'right',
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: false,
      // 滚动的距离，单位可以用%，rem等
      distance: '200px',
      // 其他可用的动画效果
      opacity: 0.001,
      easing: 'linear'
    })
  },
  methods: {
    goCallUs () {
      const btn = document.getElementById('callusForm')
      const scrollHeight = btn.offsetTop
      window.scrollTo(0, scrollHeight)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/product_page.scss';
.animo-wrap {
  margin: 0 auto;
  position: relative;
  width: 800px;
  height: 800px;
  .lightbeam {
    position: absolute;
    width: 68px;
    height: 180px;
    top: 76px;
    left: 413px;
    transform: scaleY(0);
    transform-origin: 0 100%;
    background-image: linear-gradient(to top, #3af6f9, transparent);
    animation: box3DAnimo1 3s linear infinite;
  }
}
@keyframes box3DAnimo1 {
  0% {
    opacity: 1;
    transform: scaleY(0);
  }
  20% {
    transform: scaleY(1);
  }
  70% {
    transform: scaleY(1);
  }
  100% {
    opacity: 0;
  }
}
</style>
